import type { MemberId, TicketCommand, TicketType } from '../domain/types';
import { ProtocolError } from '../protocol/crypto';

export function commandFor(action: TicketCommand['action'], actor: MemberId, note?: string): TicketCommand {
  if (action === 'reject') return { action, actor, note: note ?? '' };
  if (action === 'submit') return { action, actor, ...(note === undefined ? {} : { note }) };
  return { action, actor };
}

export function actionNotice(action: TicketCommand['action'], type: TicketType): string {
  if (action === 'accept') return '已接受这张单';
  if (action === 'reject') return '已拒绝这张单';
  if (action === 'submit') return type === 'reward' ? '兑现申请已生成' : '完成回应已生成';
  return type === 'reward' ? '已确认兑现并归档' : '已确认完成并归档';
}

export function protocolErrorCode(cause: unknown): string {
  return cause instanceof ProtocolError ? cause.code : 'PROTOCOL_INVALID';
}

export function protocolErrorMessage(cause: unknown): string {
  const code = protocolErrorCode(cause);
  if (code === 'UNSUPPORTED_VERSION') return '这条链接来自本应用尚不支持的版本。';
  if (code === 'CRYPTO_INTEGRITY') return '链接内容已损坏或不属于这个双人空间。';
  return cause instanceof Error && cause.message.includes('另一个双人空间')
    ? cause.message
    : '链接无效或不完整，请让 TA 重新复制完整链接。';
}

export function errorMessage(cause: unknown): string {
  return cause instanceof Error ? cause.message : '操作失败，请重试。';
}

export function backupErrorMessage(cause: unknown): string {
  const code = (cause as { code?: string } | null)?.code;
  if (code === 'BACKUP_DECRYPTION') return '备份口令错误或文件已损坏，现有数据未更改。';
  if (code === 'BACKUP_INVALID') return '备份文件无效或已损坏，现有数据未更改。';
  if (code === 'BACKUP_SPACE_MISMATCH') return '备份属于另一个双人空间，现有数据未更改。';
  if (code === 'BACKUP_PASSPHRASE') return '备份口令不能为空。';
  if (code === 'BACKUP_TOO_LARGE') return '备份文件不能超过 32 MiB，现有数据未更改。';
  return errorMessage(cause);
}
